import { Requirements } from 'app/routes';

import { getPromoCodeStatus } from 'components/Admin/PromoCodes/utils/getPromoCodeStatus';

import { Action } from 'store/createReducer';
import { PromoCode, PromoCodeDTO, setPromoCodes } from 'store/models/promoCodes';

const CACHE_OPTIONS = { cacheable: false };

interface PromoCodesResponse {
    promoCodes: PromoCodeDTO[];
}

export const PromoCodesRequirements: Requirements<{
    promoCodesData: PromoCodesResponse;
}> = {
    methods: () => {
        const url = '/api/v1/backoffice/promo_codes';
        return { promoCodesData: { url, ...CACHE_OPTIONS } };
    },
    resolve: ({ result: { promoCodesData } }) => {
        const promoCodesWithStatus: PromoCode[] = promoCodesData.promoCodes.map((item) => ({
            ...item,
            status: getPromoCodeStatus(item),
        }));

        const actions: Action[] = [setPromoCodes(promoCodesWithStatus)];
        return actions;
    },
};
